<template>
  <div v-if="property">
    <hr class="my-10" />
    <h1 class="text-xl font-semibold text-gray-700">Amenities</h1>
    <div class="grid grid-cols-2 gap-5 mt-5">
      <div class="" v-for="amenity in property.amenities" :key="amenity.id">
        <div class="flex items-center">
          <img :src="amenity.photo" class="w-5 h-5" alt="" />
          <span class="pl-2 leading-relaxed text-gray-500">{{
            amenity.name
          }}</span>
        </div>
      </div>
    </div>
    <hr class="my-10" />
  </div>
</template>
<script>
export default {
  props: {
    property: Object,
  },
};
</script>
